import { msalInstance } from "../auth/msalInstance";
import { apiScopes } from "../auth/msalConfig";

// Acquire an Entra access token for our own exposed API scope, to send as
// `Authorization: Bearer` on function calls. Fails soft: if the scope isn't set
// up yet, consent is missing, or the user isn't signed in, returns null and the
// caller proceeds exactly as before (so this can ship before the backend
// enforces auth without breaking anything).
export async function getApiToken() {
  try {
    const account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
    if (!account) return null;
    const res = await msalInstance.acquireTokenSilent({ scopes: apiScopes, account });
    return res?.accessToken || null;
  } catch {
    return null;
  }
}

// Spreadable Authorization header for backend fetches:
//   headers: { "Content-Type": "application/json", ...(await authHeader()) }
// Returns {} when no token is available so callers behave exactly as before.
export async function authHeader() {
  const t = await getApiToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}
